import { Div } from '@positivote/design-system/components/Div'
import { LinkButton } from '@positivote/design-system/components/LinkButton'
import { Typography } from '@positivote/design-system/components/Typography'
import { useTheme } from '@positivote/design-system/hooks'
import { Breakpoint } from '@positivote/design-system/theme'

import { EducacionalIcon } from '@/common/assets/custom-icons'
import { i18n } from '@/common/i18n'

export function BaseFooter(): JSX.Element {
  const { breakpoint } = useTheme()
  return (
    <Div
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'center',
        margin: '$4xs',
        '@xs': { margin: '$5xs' }
      }}
    >
      <Div>
        <EducacionalIcon css={{ width: 148, height: 24 }} data-testid="Icon-Educacional" />
      </Div>
      <Typography
        variant={breakpoint === Breakpoint.xs ? 'labelSmall' : 'bodySmall'}
        css={{ color: '$on-surface-variant' }}
        data-testid="Typography-copyright"
      >
        {i18n().common.layouts.baseBackground.footer.copyright}
      </Typography>
      <Div css={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <LinkButton
          onClick={() => window.open(import.meta.env.VITE_HUB_TERMS_URL)}
          typographyVariant={breakpoint === Breakpoint.xs ? 'labelSmall' : 'bodySmall'}
          data-testid="terms"
        >
          {i18n().common.layouts.baseBackground.footer.terms}
        </LinkButton>
      </Div>
    </Div>
  )
}
